class SPFormInsertField extends HTMLElement {
	connectedCallback() {
		this.form = this.closest('[data-form]');
		this.insertFieldId = this.dataset.id;
		this.button = this.querySelector('button');
		this.template = this.querySelector('template');
		this.button.addEventListener('click', this.insertField.bind(this));
		this.newIndex = 0;
	}

	insertField() {
		const field = this.template.content.cloneNode(true);

		// Get the index of the last field.
		this.newIndex = this.newIndex + 1;

		// Look through all attributes in field and child elements, and replace __index__ with the new index.
		field.querySelectorAll('*').forEach(element => {
			for (let i = 0; i < element.attributes.length; i++) {
				const attribute = element.attributes[i];
				element.setAttribute(attribute.name, attribute.value.replace(/__index__/g, `new_${this.newIndex}`));
			}
		});

		// Add the new field to the form.
		const fieldElement = field.firstElementChild;
		fieldElement.dataset.inserted = 'true';
		this.before(field);

		// Focus on the first focusable input in the new field.
		let focusableElement = null;
		const focusElements = fieldElement.querySelectorAll('input, textarea, select');
		focusElements.forEach(element => {
			if (focusableElement) return;
			if (element.disabled || element.getAttribute('tabindex') === '-1') return;
			focusableElement = element;
		});
		if (focusableElement) focusableElement.focus();

		// Emit input update event on form.
		const event = new Event('input', {
			bubbles: true,
			cancelable: true
		});
		this.form.dispatchEvent(event);
	}
}

export default () => {
	customElements.define('sp-form-insert-field', SPFormInsertField);
};